module.exports = __webpack_public_path__ + "static/home-hero-v2-e011916d4f371ea89cd61b8b22a6f79b.mp4";